module.exports = __webpack_public_path__ + "img/icon_step_content03.477c883b.png";